<div class="container" *transloco="let t">
  <div class="box">
    <p class="title">{{title}}</p>
    <app-svg-icon class="icon" [path]="'/assets/closebutton.svg'" (click)="closeEvent.emit(true)"></app-svg-icon>
    <p class="hint">{{hint}}</p>
  </div>
  <div class="search-input-wrapper">
    <form [formGroup]="searchForm" class="search-bar">
      <app-svg-icon class="icon" [path]="'/assets/searchicon.svg'"></app-svg-icon>
      <input #search
        class="search-input"
        type="text"
        [formControl]="searchForm.controls.searchInput"
        placeholder="{{ t('COMMON.LABEL.SEARCH') }}">
      <div class="clear-container">
        <app-svg-icon class="icon" [path]="'/assets/closebutton.svg'" (click)="clear()"></app-svg-icon>
      </div>
    </form>
  </div>
  <ul class="option-container">
    <li class="item" *ngFor="let option of filteredOptions" (click)="selectAndClose(option)" [innerHTML]="option.name"></li>
  </ul>
</div>
